import { ReactNode } from 'react';

import Box from '../../components/Box/Box.jsx';
import Typography from '../../components/Typography/Typography.jsx';
import UnStyledIconButton from '../Buttons/UnStyledIconButton.jsx';

export interface InputEndAdornmentProps {
  /**
   *  Input type can be Password or Text
   *  @default text
   */
  type: 'text' | 'password' | 'number' | 'email';
  /**
   * The value of the input element, required for a controlled component.
   */
  value?: string | number;
  /**
   * Icon or IconButton placed at the end
   */
  endAdornment?: ReactNode;
  /**
   * Maximum number of characters
   */
  maxLength?: number;
  /**
   * If true, the component is disabled. The prop defaults to the value (false) inherited from the parent FormControl component.
   * @default false
   */
  disabled?: boolean;
  size?: 'small' | 'medium';
  showPassword?: boolean;
  setShowPassword?: (...args: any) => void;
}
const InputEndAdornment = ({
  endAdornment,
  maxLength,
  type,
  disabled,
  value,
  size,
  setShowPassword,
  showPassword,
}: InputEndAdornmentProps) => {
  const handleClickShowPassword = () => {
    setShowPassword?.(!showPassword);
  };
  return (
    <>
      {type === 'password' ? (
        <UnStyledIconButton
          sx={{ mr: 0 }}
          size={size}
          disabled={disabled}
          aria-label="toggle password visibility"
          onClick={handleClickShowPassword}
          edge="end"
          icon={showPassword ? 'View' : 'ViewOff'}
        />
      ) : null}
      {endAdornment ? <Box>{endAdornment}</Box> : null}
      {maxLength && typeof value === 'string' ? (
        <Box>
          <Typography
            align="right"
            variant="helperText01"
            color={
              disabled
                ? (theme) => theme.palette.action.disabled01
                : (theme) => theme.palette.text.secondary
            }
          >
            {value.length}/{maxLength}
          </Typography>
        </Box>
      ) : null}
    </>
  );
};

export default InputEndAdornment;
